/**
 * When the agent's browser use floats the preview on its own.
 *
 * Ported from t3code (`apps/web/src/components/preview/previewAutomationOpenReadiness.ts`,
 * MIT, pin `e3e7cc3f`), the slice that survives forge's runtime: upstream
 * decides per agent `preview.open`/`show` request relayed through the client
 * broker, and gives agent-opened tabs a default desktop viewport; forge's
 * agent drives the browser server-side, so the decision here reads the
 * thread's browser stream activity instead, and the viewport default stays
 * with the runtime. The host budget, target, and client-id modules are not
 * ported: nothing in forge relays automation requests through the client for
 * them to serve.
 *
 * @module browserAutomationReadiness
 */
import type { BrowserThreadActivity } from "~/browser/browserPointerStore";

/**
 * Whether a fresh piece of agent activity should float the browser. An
 * explicit panel render, a floater already up, and the user's own dismissal
 * all hold it down; upstream's `open` operation is not ported because forge
 * has no agent open requests, so every activity is use.
 */
export function shouldAutoShowBrowserMiniPlayer(input: {
  readonly activity: BrowserThreadActivity | null;
  /** The panel is currently rendering the browser surface. */
  readonly renderedInPanel: boolean;
  /** A floater is already up. */
  readonly floating: boolean;
  /** The user dismissed the floater for this source. */
  readonly suppressed: boolean;
}): boolean {
  const { activity, renderedInPanel, floating, suppressed } = input;
  return (
    activity !== null && activity.actor === "agent" && !renderedInPanel && !floating && !suppressed
  );
}
